<template>

  <div id="HearingPureToneTest">
    <HearingSteps current-step="Pure_tone_test" :dot-count="0" :currentDot="0"></HearingSteps>
    <div id="PureToneTest" >


        <Headphone :starting="started" v-if="audioType == 'headphone'"></Headphone>
        <speaker :starting="started" v-if="audioType == 'speaker'"></speaker>

      <div class="clearfix"></div>
    </div>
  </div>

</template>

<script>
  import HearingSteps from './steps.vue';
  import Headphone from './HearingPureToneTestHeadphone.vue';
  import speaker from './HearingPureToneTestSpeaker.vue';
export default {
    name: 'HearingPureToneTest',

    components: {
        HearingSteps,
        Headphone,
        speaker
    },
  mounted() {
      // check user passed prev steps, if not go home!
      if(!window.questionsAnswer || !window.calibrationAnswers)
          this.$parent.$router.replace('/');


    //TODO: be ok in Hereee!
      this.audioType = window.calibrationAnswers ? window.calibrationAnswers.type : 'speaker';


  },
  data () {

    return {
        audioType : 'speaker',
        started :false,
        currTest:1,
        answers : [],
    }
  },
    methods:{
        startPureToneTest(){
            this.started=true;
            //this.$root.$emit('startingTest');
        }
    }
}
</script>

<style scoped>
  #PureToneTest{
    margin: 40px 0;
    text-align: center;
    padding: 0 10px 30px;
  }
  #PureToneTest button{
    text-align: center;
    cursor: pointer;
    border: none;
    float: right;
    width: 34%;
    margin: 0 8%;
    padding-top: 12px;
    padding-bottom: 10px;
    background-color: #00b7c6;
    font-weight: normal;
    font-style: normal;
    font-size: 24px;
    line-height: 20px;
    color: #fff;
    -webkit-box-shadow: 0px 5px 5px 0px rgba(0, 0, 0, 0.15);
    -moz-box-shadow: 0px 5px 5px 0px rgba(0, 0, 0, 0.15);
    box-shadow: 0px 5px 5px 0px rgba(0, 0, 0, 0.15);
  }
  .HearingTest-test--title {
    text-align: center;
    margin-bottom: 10px;
    font-weight: normal;
    font-style: normal;
    font-size: 54px;
    line-height: 52px;
    color: #00b7c6;
  }
  .HearingTest-test--text {
    text-align: center;
    margin-bottom: 20px;
    font-weight: normal;
    font-style: normal;
    font-size: 16px;
    line-height: 22px;
    color: #000;
  }
  .HearingTest-test--calibrationContainer {
    display: block;
    padding: 15px 0 0;
    position: relative;
    height: 150px;
    text-align: center;
    width: 100px;
    margin: 0 auto;
  }

  .HearingTest-test--calibrationContainer .HearingTest-test--volumeContainer {
    float: left;
    width: 100px;
    margin-top: 18px;
  }
  .HearingTest-test--calibrationContainer .HearingTest-test--spinnerBubbles {
    width: 100px;
    height: 100px;
    margin-top: 10px;
    position: absolute;
  }
  .HearingTest-test--calibrationContainer .HearingTest-test--spinnerBubbles .HearingTest-test--playButtonContainer {
    position: absolute;
    width: 76px;
    height: 76px;
    margin: 11px 12px 0 0;
    background-color: #b5be00;
    border-radius: 100px;
    cursor: pointer;
    z-index: 5;
    box-shadow: 0px 0px 1px;
  }
  .HearingTest-test--calibrationContainer .HearingTest-test--spinnerBubbles .HearingTest-test--playButtonContainer .HearingTest-test--frequency {
    margin-top: 18px;
    font-weight: normal;
    font-style: normal;
    font-size: 32px;
    line-height: 22px;
    color: #fff;
    text-align: center;
  }
  .HearingTest-test--calibrationContainer .HearingTest-test--spinnerBubbles .HearingTest-test--spinnerBubble {
    position: relative;
    background-color: #ffffff;
    border: 1px solid #231f20;
    height: 15px;
    width: 15px;
    border-radius: 15px;
    box-sizing: content-box;
    -webkit-box-sizing: content-box;
    -moz-box-sizing: content-box;
  }
  .HearingTest-test--toneButton {
    text-align: center;
    width: 120px;
    margin: 10px auto 0;
    cursor: pointer;
    background-color: #00b7c6;
    padding-top: 9px;
    padding-bottom: 7px;
    font-weight: normal;
    font-style: normal;
    font-size: 22px;
    line-height: 22px;
    color: #fff;
    -webkit-box-shadow: 0px 5px 5px 0px rgba(0, 0, 0, 0.15);
    -moz-box-shadow: 0px 5px 5px 0px rgba(0, 0, 0, 0.15);
    box-shadow: 0px 5px 5px 0px rgba(0, 0, 0, 0.15);
  }
</style>



// WEBPACK FOOTER //
// src/components/HearingTest/HearingPureToneTest.vue